import { FC } from 'react';
import { MLPVersion, Search, useTranslation } from '@nextgen-web-framework/all';
import { ConsoleLogger } from '@nextgen-web-framework/core';
import { AreaFilter } from '@commerce-profile-webcomponents/ui';
import { checkoutApi, ICheckoutAnyType } from '@commerce-checkout-webcomponents/sdk';
import { ICheckoutStoreFilterProps } from '../types/propTypes';
import { checkoutShippingDetailsActions } from '../../common/config/checkoutConstants';
import { stateTextLocalization } from '../../common/transformer';
import styles from './CheckoutStoreFilter.module.scss';

export const CheckoutStoreFilter: FC<ICheckoutStoreFilterProps> = ({
  searchValue = '',
  onClearSearch,
  dispatchAction,
  showFilterDrawerContent,
  onFilterSelection,
}: ICheckoutStoreFilterProps) => {
  const t = useTranslation();
  const [state, city] = searchValue?.split(',') || [];

  const getDaneCodeUsingFilter = async (filters: ICheckoutAnyType) => {
    const daneCodeResponse = await checkoutApi.getDaneCode({ city: filters?.city, state: filters?.state });
    dispatchAction({ type: checkoutShippingDetailsActions.SET_STORE_FILTER_VISIBILITY, payload: false });
    dispatchAction({ type: checkoutShippingDetailsActions.SET_STORE_MAP, payload: undefined });
    dispatchAction({
      type: checkoutShippingDetailsActions.SET_SELECTED_STORE_FILTERS,
      payload: `${filters?.state},${filters?.city}`,
    });
    onFilterSelection && onFilterSelection({ ...filters, daneCode: daneCodeResponse?.[0] });
  };

  const searchValueLocalized = () => {
    if (state && city) {
      return `${stateTextLocalization(state, t, 'profile.contactmasterdata.v1.draft.stateCode.')}, ${city}`;
    }
    return '';
  };

  return (
    <div className={styles['checkout-store-filter']} data-testid="checkout-store-filter">
      {!showFilterDrawerContent && (
        <div className={styles['checkout-store-filter-input']}>
          <Search
            mlpVersion={MLPVersion.TWO}
            className={styles['searchFilterInput']}
            value={searchValueLocalized()}
            onSearch={() => {
              ConsoleLogger.log('SEARCH IS NOT APPLICABLE');
            }}
            onClear={() => {
              dispatchAction({
                type: checkoutShippingDetailsActions.SET_SELECTED_STORE_FILTERS,
                payload: '',
              });
              dispatchAction({
                type: checkoutShippingDetailsActions.SET_STORE_PIN,
                payload: '',
              });
              onClearSearch && onClearSearch();
            }}
            data-testId="search-filter-state-city"
            onChange={() => {
              ConsoleLogger.log('Using Search as filter');
            }}
            placeholder={t('checkout.CheckoutPickupDrawer.filterLabel')}
          />
          <div
            className={styles['checkout-store-filter-trigger-cta']}
            onClick={() => {
              dispatchAction({
                type: checkoutShippingDetailsActions.SET_STORE_FILTER_VISIBILITY,
                payload: true,
              });
            }}
            role="presentation"
            data-testid="checkout-store-filter-cta"
          ></div>
        </div>
      )}
      {showFilterDrawerContent && (
        <div className={styles['checkout-store-filter-drawer-content']}>
          <AreaFilter
            callback={(filters) => {
              getDaneCodeUsingFilter(filters);
            }}
            className={styles['checkout-state-city-filter']}
            state={state}
            city={city}
          />
        </div>
      )}
    </div>
  );
};

export default CheckoutStoreFilter;
